import { useMemo } from "react";
import { useParams } from "react-router";
import { ResourceType } from "../resource";
import { makePath } from "../util/makePath";

const resourceTypePaths: {
  [key in ResourceType]: readonly string[];
} = {
  account: ["account"],
  pipeline: ["pipelines"],
  connection: ["connections"],
  stream: ["streams"],
  user: ["access", "users"],
  group: ["access", "groups"],
  role: ["access", "roles"],
  secret: ["secrets"],
} as const;

export function usePath({
  accountName,
  resourceType,
  resourceId,
}: {
  accountName?: string;
  resourceType?: keyof typeof resourceTypePaths;
  resourceId?: string;
} = {}) {
  const { accountName: accountNameFromPath } = useParams();

  return useMemo(() => {
    if (!accountName) {
      accountName = accountNameFromPath;
    }

    if (!resourceType) {
      return makePath([accountName]);
    }

    if (!resourceId) {
      return makePath([accountName, ...resourceTypePaths[resourceType]]);
    }

    return makePath([
      accountName,
      ...resourceTypePaths[resourceType],
      resourceId,
    ]);
  }, [accountNameFromPath, accountName, resourceType, resourceId]);
}
